export const user_routes = [
	{
        path: '/:lang([a-z]{1,3})?',
        name: 'lang',
        // component: () => import('@/App.vue'),
        // props: { data: { page: "Default", data: {} } },
        // meta: { requireAuth: true },
        children: [
			{
				path: '',
				name: 'index',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Home" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			{
				path: 'about',
				name: 'about',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/About" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			{
				path: 'contacts',
				name: 'contacts',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Contacts" } },
				// props: { data: { page: "Home", data: {uid: 1} } },
				meta: { requireAuth: false },
				// children: []
			},
			// {
			// 	path: 'services',
			// 	name: 'services',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Services" } },
			// 	// props: { data: { page: "Home", data: {uid: 1} } },
			// 	meta: { requireAuth: false },
			// 	// children: []
			// },
			{
				path: 'menu/:id(\\d+)',
				name: 'menu_detail',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Menu" } },
				meta: { requireAuth: false },
			},
			{
				path: 'post/:id(\\d+)',
				name: 'post_detail',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Post" } },
				meta: { requireAuth: false },
			},
			{
                // path: 'posts/:category_id(\\d+)/:author_id(\\d+)/:page(\\d+)/:perpage(\\d+)/:sortfield/:sortorder/:filters/:search_text?',
                // path: 'posts/:category_id(\\d+)/:author_id(\\d+)/:page(\\d+)/:perpage(\\d+)/:search_text?',
                path: 'posts/:category_id(\\d+)?/:page(\\d+)?/:perpage(\\d+)?/:search_text?',
                name: 'post_paging',
                component: () => import('@/layouts/Main'),
                props: { data: { page: "pages/Posts" } },
                // meta: { requireAuth: true },
            },
			// {
			// 	path: 'tv',
			// 	name: 'tv',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/TV" } },
			// 	meta: { requireAuth: false },
			// },
			{
				// path: 'tvs/:category_id/:author_id/:page/:perpage/:sortfield/:sortorder/:filters/:search_text?',
				path: 'tv/:page(\\d+)?/:perpage(\\d+)?/:search_text?',
				name: 'tv',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/TV" } },
				meta: { requireAuth: false },
			},
			// {
			// 	path: 'authors',
			// 	name: 'authors',
			// 	component: () => import('@/layouts/Main'),
			// 	props: { data: { page: "pages/Authors" } },
			// 	meta: { requireAuth: false },
			// },
			{
				// path: 'authors/:category_id/:author_id/:page/:perpage/:sortfield/:sortorder/:filters/:search_text?',
				path: 'authors/:page(\\d+)?/:perpage(\\d+)?/:search_text?',
				// name: 'authors_paging',
				name: 'authors',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/Authors" } },
				meta: { requireAuth: false },
			},
			{
				// path: 'authors/:category_id/:author_id/:page/:perpage/:sortfield/:sortorder/:filters/:search_text?',
				path: 'author/:author_id(\\d+)/:author_name/:search_text?',
				name: 'author_detail',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/AuthorPosts" } },
				meta: { requireAuth: false },
			},
			{
				// path: 'authors/:category_id/:author_id/:page/:perpage/:sortfield/:sortorder/:filters/:search_text?',
				path: 'author/:author_id(\\d+)/:author_name/:page(\\d+)/:perpage(\\d+)/:search_text?',
				name: 'author_post_paging',
				component: () => import('@/layouts/Main'),
				props: { data: { page: "pages/AuthorPosts" } },
				meta: { requireAuth: false },
			},
		],
	},
	{
		// path: '/:lang([a-z]{1,3})/?:catchAll(.*)',
		path: '/:catchAll(.*)',
		name: '404error',
		// redirect: 'notfound',
		// component: () => import('@/layouts/404'),
		// // props: { data: { page: "pages/NotFound" } },
		component: () => import('@/layouts/404'),
		props: { data: { page: "pages/NotFound" } },
		// beforeEnter (to, from, next) {
		// 	to.params.test = 'test'
		// 	next(to.params)
		// }
	},
];
